"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import CheckIcon from "@mui/icons-material/Check";
export default function WorkTypeSelector(t0) {
  const $ = _c(12);
  const {
    options,
    selected,
    onToggle
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Image src="/icons/contract_edit.svg" alt="" width={22} height={22} className="shrink-0" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="m3-label-large text-[--textPrimaryPrimary]">What kind of work is it?</p>;
    t3 = <p className="m3-body-small text-[--textSecondarySecondary]">Select all that apply</p>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== onToggle || $[4] !== options || $[5] !== selected) {
    let t5;
    if ($[7] !== onToggle || $[8] !== selected) {
      t5 = option => {
        const isSelected = selected.includes(option.value);
        return <button key={option.value} type="button" onClick={() => onToggle(option.value)} aria-pressed={isSelected} className={`m3-label-large flex items-center gap-1.5 rounded-[--radius100] px-4 py-2 transition-colors ${isSelected ? "bg-[--colorPrimaryOnPrimaryContainer] text-[--textPrimaryOnColorPrimary]" : "border border-[--colorOutlineOutline] text-[--textSecondarySecondary]"}`}>{isSelected && <CheckIcon sx={{
            fontSize: "16px"
          }} />}{option.label}</button>;
      };
      $[7] = onToggle;
      $[8] = selected;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    t4 = options.map(t5);
    $[3] = onToggle;
    $[4] = options;
    $[5] = selected;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = <div className="flex flex-col gap-3"><div className="flex items-start gap-4">{t1}<div className="flex flex-col gap-4">{t2}{t3}<div className="flex flex-wrap gap-2">{t4}</div></div></div></div>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}